// imports
import Component from 'minsky-kit/js/components/Component';
import * as Klaro from 'klaro/dist/klaro-no-css';
import Config from '../../Config';

const LANGS = ['ca', 'cs', 'da', 'de', 'el', 'en', 'es', 'fi', 'fr', 'gl', 'hr', 'hu', 'it', 'nl', 'no', 'pl', 'pt', 'ro', 'ru', 'sr', 'sv', 'tr', 'zh'];

// class definition
export default class CookieConsent extends Component {
    // constructor
    constructor (args = {}, objectName = 'CookieConsent') {
        // super
        super(args, objectName);

        const config = Config.klaroConfig;

        for (let i = 0; i < LANGS.length; i++) {
            const lang = LANGS[i];
            config.translations[lang] = config.translations.zz;
        }

        this.consent = Klaro.setup(config);

        this.$trigger = document.querySelector('.js-cookie-trigger');

        // listener
        if (this.$trigger) {
            this.$trigger.addEventListener('click', this.blm.add('onTriggerClick', onTriggerClick));
        }
    }

    show () {
        Klaro.show();
    }

    // methods
    destroy () {
        super.destroy();
    }
}

function onTriggerClick (e) {
    e.preventDefault();
    this.show();
}
